// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"23723":"84e230083d4bf637","26969":"dc2d2cd9bdbf75cf","93063":"9e3ecbc360ffcaad"}[chunkId] + ".css";
};